<template>
    <div>
        <div v-if="!finished">
            <div v-if="trip.status===3 || trip.status===7">
                <div class="container-fluide mx-3 px-4 py-4 bg-light rounded-lg">
                    <div class="row">
                        <div class="container">
                            <div class="box">
                                <div class="app">
                                    <section class="register">
                                        <transition name="slide-fade">
                                            <section class="congrats register">
                                                <div v-if="trip.status===3">
                                                    <h2 class="congrats-title">
                                                        Din tur er allerede planlagt af vores administration og kan
                                                        derfor ikke længere laves om. Kontakt venligst på 50 24 50 50
                                                        eller booking@steptransport.dk hvis du har nogen
                                                        indvendinger. </h2>
                                                </div>
                                                <div v-if="trip.status===7">
                                                    <h2 class="congrats-title">
                                                        Din tur er allerede afsluttet og kan derfor ikke laves om.
                                                    </h2>
                                                </div>
                                            </section>
                                        </transition>
                                    </section>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

            </div>
            <div v-else>
                <div class="flex-center position-ref full-height">
                    <div :class="step !== 1 ? 'blurred' : ''"
                         class="container-fluide mx-3 px-4 py-4 bg-light rounded-lg">
                        <div class="row">
                            <div class="container">
                                <div class="box">
                                    <div class="app">
                                        <section v-if="!finished" class="register">
                                            <transition name="slide-fade">
                                                <section>
                                                    <h5> Levering fra {{ this.trip.client.name }} til
                                                        {{ address }} </h5>
                                                    <br>
                                                    <form action="#" class="form" @submit.prevent="next()">
                                                        <h3> Vælg tidspunkt </h3>
                                                        <div v-if="step===1">
                                                            <div v-if="availableDates.length>0">
                                                                <div class="box-left">
                                                                    <div
                                                                        v-for="(date,k) in availableDates.slice(displayedDatesFrom, displayedDatesTo)"
                                                                        class="form-group">
                                                                        <label>
                                                                            <input v-model="delivery.date"
                                                                                   :value=date
                                                                                   name="date"
                                                                                   required
                                                                                   type="radio">
                                                                            {{ date.date }}
                                                                            {{ date.from }} - {{ date.to }}
                                                                        </label>
                                                                    </div>
                                                                </div>
                                                                <br/>
                                                                <div class="btn btn-success"
                                                                     @click="displayedDatesTo+=3">
                                                                    Indlæs flere muligheder
                                                                </div>
                                                            </div>
                                                            <div v-else>
                                                                <!--                                                                Der er desværre ingen ledige datoer. Ring til Step-->
                                                                <!--                                                                Transport-->
                                                                <!--                                                                på-->
                                                                <!--                                                                +45 50 24 50 50 mandag til fredag mellem 10.00 og 14.00-->
                                                                <!--                                                                for-->
                                                                <!--                                                                at-->
                                                                <!--                                                                finde et tidspunkt der passer dig-->


                                                                For at aftale nyt leveringstidspunkt, <br/>
                                                                bedes du ringe til Step Transport<br/>
                                                                på +45 50 24 50 50 alle hverdage <br/>
                                                                mellem 08.00 og 17.00.<br/>
                                                                Så finder vi et tidspunkt der passer dig.<br/>
                                                            </div>
                                                            <div class="cta" data-alignment="right"
                                                                 data-style="see-through"
                                                                 data-text-color="custom">
                                                                <div class="cta-color">
                                                                    <br/>
                                                                    <div class="link_wrap">
                                                            <span class="vertical-align-middle material-icons pr-2">

                                                            </span>
                                                                        <button class="btn btn-default btn-sm">
                                                                            <i class="oi oi-chevron-bottom"></i>
                                                                        </button>
                                                                    </div>

                                                                </div>
                                                            </div>
                                                        </div>
                                                        <div v-else>
                                                            {{ delivery.date.date }}
                                                            {{ delivery.date.from }} - {{ delivery.date.to }}
                                                        </div>
                                                    </form>
                                                </section>
                                            </transition>
                                        </section>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="clearfix">

                </div>

                <div class="flex-center position-ref full-height">
                    <div :class="step !== 2 ? 'blurred' : ''"
                         class="container-fluide mx-3 px-4 py-4 bg-light rounded-lg">
                        <div class="row">
                            <div class="container">
                                <div class="box">
                                    <div class="app">
                                        <section v-if="!finished" class="register">
                                            <transition name="slide-fade">
                                                <section>
                                                    <form class="form" @submit.prevent="complete">
                                                        <h3> Bekræft </h3>

                                                        <div v-if="step===2" class="form-group">
                                                            <h5> Adresse </h5>
                                                            {{ delivery.address || address }}<br/><br/>
                                                            <h5> Leveringsservice </h5>
                                                            {{ delivery.changeServiceText }}<br/><br/>
                                                            <h5> Leveringstidspunkt </h5>
                                                            {{ delivery.date.date }}
                                                            {{ delivery.date.from }} - {{ delivery.date.to }}
                                                            <br/><br/>
                                                            <!--                                                            <h5> Fudmagt </h5>-->
                                                            <!--                                                            {{ delivery.fudmagt }}<br/><br/>-->
                                                        </div>

                                                        <!--                                                <div class="form-group cta-step">
                                                                                                            <div class="cta prev">
                                                                                                                <p class="cta-color">
                                                                                        <span class="link_wrap">
                                                                                            <a class="link_text" href="#" @click.prevent="prev()"><span
                                                                                                class="arrow-prev"></span>Previous
                                                                                            </a>
                                                                                        </span>
                                                                                                                </p>
                                                                                                            </div>
                                                                                                        </div>-->
                                                        <div class="register-btn">
                                                            <button class="btn btn-success"> Bekræft</button>
                                                        </div>
                                                    </form>
                                                </section>
                                            </transition>
                                        </section>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div v-else class="flex-center position-ref full-height">
            <div class="container-fluide mx-3 px-4 py-4 bg-light rounded-lg">
                <div class="row">
                    <div class="container">
                        <div class="box">
                            <div class="app">
                                <section class="register">
                                    <transition name="slide-fade">
                                        <section class="congrats register">
                                            <div v-if="optimoRouteError">
                                                <p class="congrats-subtitle"><br/>
                                                    {{ optimoRouteError }}
                                                </p>
                                            </div>
                                            <div v-else>
                                                <h2 class="congrats-title">Dine ændringer er hermed gemte.</h2>
                                            </div>
                                        </section>
                                    </transition>
                                </section>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>

</template>

<script>

export default {
    name: "Rate",
    props: {
        tripData: {type: String, required: true},
    },
    data() {
        return {
            steps: {},
            step: 1,
            completed_step: 0,
            changeService: false,
            changeFuldmagt: false,
            delivery: {
                address: '',
                changeServiceText: '',
                date: '',
                fuldmagt: '',
                zip_code: '',
            },
            availableDates: [],
            displayedDatesFrom: 0,
            displayedDatesTo: 3,
            finished: false,
            optimoRouteError: '',
        }
    },
    methods: {
        prev() {
            this.step--;
        },
        next() {
            if (this.delivery.zip_code !== '') {
                this.step++;
                this.scrollTo({behavior: 'smooth'}, `step-${this.step}`)
            }
        },
        scrollTo(options, elementToScroll) {
            const el = this.$el.getElementsByClassName(elementToScroll)[0];
            if (el) {
                el.scrollIntoView(options);
            }
        },
        async complete() {
            this.finished = true;
            this.optimoRouteError = '';
            this.delivery.trip = this.trip;
            if (this.delivery.address === '') {
                this.delivery.address = this.address;
            }
            try {
                const deliveryResponse = await axios.post('/deliveries', this.delivery);
                const tripResponse = await axios.post(`/optimoroute/create-order/${this.trip.id}/0`, this.trip);

                if (tripResponse.data.response[this.trip.id].success === false) {
                    this.optimoRouteError = 'Der opstod en fejl. Kontakt venligst Step Transport på +45 50 24 50 50 eller booking@steptransport.dk';
                }

                if (this.trip.child_trip) {
                    const childTripResponse = await axios.post(`/optimoroute/create-order/${this.trip.child_trip}/0`, this.trip);
                }
            } catch (error) {
                console.log(error);
            }
        },
        getDates() {
            const matchZip = this.address.match(/\d{4}/);
            if (matchZip) {
                this.delivery.zip_code = matchZip[0];
                axios.get(`/mobile/check-delivery/get-available-dates/${this.delivery.zip_code}/${parseInt(this.trip.id)}`).then((response) => {
                    this.availableDates = response.data.data;
                }).catch(e => {
                })
            } else {
                alert("zip code not found in address");
            }
        }
    },
    created() {
        this.getDates()
    },
    computed: {
        trip: function () {
            return JSON.parse(this.tripData)
        },
        address: {
            get: function () {
                return `${this.trip.address.street} ${this.trip.address.zip}, ${this.trip.address.city}`
            },
            set: function (newValue) {
                this.delivery.address = newValue;
            }
        },
    }
}
</script>

<style scoped>
.box {
    margin: 5px;
    text-align: center;
}

.box-left {
    margin: 5px;
    text-align: left;
}

.blurred {
    opacity: 50%;
}

.clearfix {
    height: 20px;
}

.switch {
    position: relative;
    display: inline-block;
    width: 60px;
    height: 34px;
}

/* Hide default HTML checkbox */
.switch input {
    opacity: 0;
    width: 0;
    height: 0;
}

/* The slider */
.slider {
    position: absolute;
    cursor: pointer;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-color: #ccc;
    -webkit-transition: .4s;
    transition: .4s;
}

.slider:before {
    position: absolute;
    content: "";
    height: 26px;
    width: 26px;
    left: 4px;
    bottom: 4px;
    background-color: white;
    -webkit-transition: .4s;
    transition: .4s;
}

input:checked + .slider {
    background-color: #2196F3;
}

input:focus + .slider {
    box-shadow: 0 0 1px #2196F3;
}

input:checked + .slider:before {
    -webkit-transform: translateX(26px);
    -ms-transform: translateX(26px);
    transform: translateX(26px);
}

/* Rounded sliders */
.slider.round {
    border-radius: 34px;
}

.slider.round:before {
    border-radius: 50%;
}
</style>
